import { useIsFeatureEnabled } from '~/shared/lib/feature-flags'
import { LocalIcon, RadioButton } from '~/shared/ui'
import { useFilters } from '../../../model'

export function StatusFilter() {
  const { filters, setFilters } = useFilters()
  const isAutoReviewedEnabled = useIsFeatureEnabled('2026-06-auto-reviewed')

  return (
    <>
      <div className="flex items-center px-2 py-0.5">
        <RadioButton
          label="Awaiting / In Progress"
          gutter
          size="small"
          checked={filters.status.includes('awaiting')}
          onChange={() => {
            setFilters({
              status: ['awaiting'],
            })
          }}
        />
      </div>
      <div className="flex items-center px-2 py-0.5">
        <RadioButton
          label="Finished"
          gutter
          size="small"
          checked={filters.status.includes('finished')}
          onChange={() => {
            setFilters({
              status: ['finished'],
            })
          }}
        />
      </div>
      {isAutoReviewedEnabled && (
        <div className="flex items-center justify-between px-2 py-0.5">
          <RadioButton
            label="Auto Finished"
            gutter
            size="small"
            checked={filters.status.includes('auto_reviewed')}
            onChange={() => {
              setFilters({
                status: ['auto_reviewed'],
              })
            }}
          />
          <LocalIcon
            className="text-text-secondary mr-1"
            name="optiWink"
          />
        </div>
      )}
      <div className="flex items-center justify-between px-2 py-0.5">
        <RadioButton
          label="Processing"
          gutter
          size="small"
          checked={filters.status.includes('processing')}
          onChange={() => {
            setFilters({
              status: ['processing'],
            })
          }}
        />
        <LocalIcon
          className="text-text-secondary mr-1"
          name="optiBot"
        />
      </div>
    </>
  )
}
